// store.js

import { configureStore } from "@reduxjs/toolkit";
import changeState from './StateStore/reducer'
import selectedUserReducer from './userSlected/index'
const store = configureStore({
  reducer: {
    changeState: changeState,
    selectedUser: selectedUserReducer,
  },
});

export default store;
